import { useAbility } from "@/casl-provider";
import { checkPermission, getNavigationLinkTarget } from "@/common/helpers/navigation";
import { ButtonColorVariant, ButtonSize, ButtonVariant, buttonVariants } from "@/components/ui/button";
import { NavigationItem } from "@/config/navigation/types";
import { userStore } from "@/store/user-store";
import { Link } from "wouter";

interface NavigationCardItemProps {
  item: NavigationItem;
}

export function NavigationCardItem({ item }: NavigationCardItemProps) {
  const ability = useAbility();
  const user = userStore((state) => state.user);

  if (item.permission && ability) {
    if (!checkPermission(ability, item.permission, user?.roles)) {
      return null;
    }
  }

  const Icon = item.icon;
  const linkTarget = getNavigationLinkTarget(item) ?? "#";

  return (
    <Link
      to={linkTarget}
      className={buttonVariants({
        variant: ButtonVariant.Outlined,
        colorVariant: ButtonColorVariant.Secondary,
        size: ButtonSize.Lg,
      })}
    >
      {Icon && <Icon />} {item.title()}
    </Link>
  );
}
